import { InjectionToken, NgModule } from '@angular/core';
import { ActivatedRouteSnapshot, RouterModule, Routes } from '@angular/router';
import { AuthComponent } from './authentification/auth/auth.component';
import { ConfirmRegisterComponent } from './authentification/confirm-register/confirm-register.component';
import { WelcomeComponent } from './authentification/welcome/welcome.component';
import { ActuLigueComponent } from './component/actu-ligue/actu-ligue.component';
import { ActuComponent } from './component/actu/actu.component';
import { FluxRssComponent } from './component/baseComponent/flux-rss/flux-rss.component';
import { LabelValeurComponent } from './component/baseComponent/label-valeur/label-valeur.component';
import { UrlComponent } from './component/baseComponent/url/url.component';
import { YoutubeComponent } from './component/baseComponent/youtube/youtube.component';
import { ClubComponent } from './component/club/club.component';
import { ConditionsComponent } from './component/conditions/conditions.component';
import { ErrorComponent } from './component/error/error.component';
import { Error500Component } from './component/error500/error500.component';
import { ForgotPasswordComponent } from './component/forgot-password/forgot-password.component';
import { HomeComponent } from './component/home/home.component';
import { LicenceComponent } from './component/licence/licence.component';
import { LoadingComponent } from './component/loading/loading.component';
import { MeteoComponent } from './component/meteo/meteo.component';
import { ParametersComponent } from './component/parameters/parameters.component';
import { ProfilComponent } from './component/profil/profil.component';
import { UnsubscribeComponent } from './component/profil/unsubscribe/unsubscribe.component';
import { RegatesComponent } from './component/regates/regates.component';
import { ResetPasswordSendComponent } from './component/reset-password-send/reset-password-send.component';
import { ResetPasswordComponent } from './component/reset-password/reset-password.component';
import { ChoicePersonaComponent } from './component/search-user-licence/choice-persona/choice-persona.component';
import { SearchUserLicenceComponent } from './component/search-user-licence/search-user-licence.component';
import { AuthGuard } from './shared/helpers/auth.guard';

const externalUrlProvider = new InjectionToken('externalUrlRedirectResolver');
const deactivateGuard = new InjectionToken('deactivateGuard');


const routes: Routes = [
  {
    path: 'conditions',
    component: ConditionsComponent,
  },

  {
    path: 'youtube',
    component: YoutubeComponent,
  },
  {
    path: 'lv',
    component: LabelValeurComponent,
  },
  {
    path: 'sportysky',
    component: MeteoComponent,

  },
  {
    path: 'url',
    component: UrlComponent,

  },
  {
    path: 'rss',
    component: FluxRssComponent,

  },

  {
    path: 'licence',
    component: LicenceComponent,
    canActivate: [AuthGuard]
  },

  {
    path: 'clubs',
    component: ClubComponent,
  },
  {
    path: 'regates',
    component: RegatesComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'meteo2',
    component: MeteoComponent,
  },
  {
    path: 'meteo',
    component: MeteoComponent,
  },

  {
    path: 'actus-ligue',
    component: ActuLigueComponent,
  },
  {
    path: 'actus',
    component: ActuComponent,
  },
  {
    path: 'profil/unsubscribe',
    component: UnsubscribeComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'profil',
    component: ProfilComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'parametres',
    component: ParametersComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'choice-persona',
    component: ChoicePersonaComponent,
    // canActivate: [AuthGuard]

  },
  {
    path: 'link-your-account',
    component: SearchUserLicenceComponent,
    // canActivate: [AuthGuard]

  },
  {
    path: 'home',
    component: HomeComponent,
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent
  },
  {
    path: 'reset-password-send',
    component: ResetPasswordSendComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'welcome',
    component: WelcomeComponent
  },
  {
    path: 'confirm-register',
    component: ConfirmRegisterComponent
  },
  {
    path: 'login',
    component: AuthComponent
  },
  {
    path: 'error500',
    component: Error500Component,
  },
  {
    path: '',
    component: LoadingComponent,
    pathMatch: 'full'
  },
  {
    path: '**',
    component: ErrorComponent,

  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    {
      provide: externalUrlProvider,
      useValue: (route: ActivatedRouteSnapshot) => {

        const externalUrl = route.paramMap.get('externalUrl');
        window.open(externalUrl, '_self');
      },
    },
    {
      provide: deactivateGuard,
      useValue: () => {
        // console.log('Guard function is called!');

        return false;
      }
    },
  ],
})
export class AppRoutingModule { }
